<template>
  <div class="min-h-screen px-4">
    <template>
      <div class="grid grid-cols-3">
        <div></div>
        <div></div>
        <input
          v-model="employee"
          @input="handleInputChange('employee')"
          type="text"
          placeholder="Employee"
          class="rounded-full w-full pl-4 py-1.5"
        />
<!--        <input
          v-model="department"
          @input="handleInputChange('department')"
          type="text"
          placeholder="Department"
          class="rounded-full w-full pl-4 py-1.5"
        />
        <input
          v-model="location"
          @input="handleInputChange('location')"
          type="text"
          placeholder="Location"
          class="rounded-full w-full pl-4 py-1.5"
        />-->
      </div>
    </template>

    <div
      v-if="loading"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 mt-5 p-5 bg-white rounded-lg"
    >
      <el-skeleton
        style="width: 240px"
        :loading="loading"
        animated
        v-for="(emp, index) in Array.from({ length: 10 })"
        :key="index"
      >
        <template slot="template">
          <el-skeleton-item
            variant="image"
            style="width: 240px; height: 240px"
          />
          <div style="padding: 14px">
            <el-skeleton-item variant="h3" style="width: 50%" />
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 16px;
                height: 16px;
              "
            >
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="width: 30%" />
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
    <div>
      <!-- {{ employees[0] }} -->
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 mt-5 p-5 bg-white rounded-lg"
        v-if="employees.length"
      >
        <div v-for="(emp, index) in filteredEmployees" :key="index">
          <div class="text-center border-1.5 rounded-lg p-3">
            <div class="flex flex-col items-center justify-center">
              <div
                class="h-16 w-16 rounded-full bg-gray-400 flex items-center justify-center"
              >
                <img
                  v-if="emp.ProfilePicture"
                  class="h-full w-full rounded-full object-cover"
                  :src="emp.ProfilePicture"
                  :alt="
                    getInitials(decryptDataLocal(emp.Fullname, decryptionKey))
                  "
                />

                <span class="text-white" v-else>
                  {{
                    getInitials(decryptDataLocal(emp.Fullname, decryptionKey))
                  }}
                </span>
              </div>

              <p class="font-bold my-3 text-sm">
                {{ decryptDataLocal(emp.Fullname, decryptionKey) }}
              </p>

              <p class="my-2 text-xs">
                {{ emp?.RoleName }}
              </p>
            </div>
            <div class="flex flex-col flex-wrap">
              <p class="my-2 text-xs">
                Phone:
                <span class="text-blue-500">
                  {{ decryptDataLocal(emp.WorkPhoneNumber, decryptionKey) }}
                </span>
              </p>
              <p class="my-2 overflow-hidden w-full text-xs">
                Email:
                <span class="text-blue-500">
                  {{ decryptDataLocal(emp.WorkEmail, decryptionKey) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!loading && filteredEmployees.length === 0"
        class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
// import Loader from "@/components/loader/loader.vue";
import { viewSecuredAttachment } from "@/utils/secureAttachmentsViewer";
import debounce from "lodash/debounce";
import decryptData from "@/utils/decrypt";


export default {
  name: "Directory",
  components: {
    // Loader,
  },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      employee: "",
      department: "",
      location: "",
      employees: [],
      get_error: null,
      loading: false,
      profilePicUrl: "",
      filteredEmployees: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.getEmployees();
  },
  methods: {
    handleInputChange: debounce(function () {
      const employeeSearchTerm = this.employee?.toLowerCase().trim();
      const departmentSearchTerm = this.department?.toLowerCase().trim();
      const locationSearchTerm = this.location?.toLowerCase().trim();

      // Check if all search terms are empty
      if (
        employeeSearchTerm === "" &&
        departmentSearchTerm === "" &&
        locationSearchTerm === ""
      ) {
        this.filteredEmployees = this.employees; // Return all employees if no search terms
      } else {
        // Perform the filtering based on Fullname, Department, and Location
        this.filteredEmployees = this.employees.filter((employee) => {
          const fullnameMatch = decryptData(
            employee.Fullname,
            this.$decryptionKey
          )
            .toLowerCase()
            .includes(employeeSearchTerm);
          return fullnameMatch;
        });
      }

      console.log("Filtered Employees:", this.filteredEmployees);
    }, 300),

    getInitials(fullname) {
      //decrypt the name
      const names = decryptData(fullname, this.$decryptionKey).trim().split(' ')

      //Get the initials
      const firstInitial = names[0] ? names[0][0].toUpperCase() : '';
      const secondInitial = names[1] ? names[1][0].toUpperCase() : ''

      //Return the combined initials
      return `${firstInitial}${secondInitial}`
    },
    onChange() {
      this.$router.push({
        params: { company: this.getOrganization },
        name: "dashboard",
      });
      this.$store.commit("setUserType", this.user);
      if (this.getRouteTo == "dashboard") {
        this.$router.push({
          params: { company: this.getOrganization },
          name: this.getFilteredMenu[0].route,
        });
      }
    },

    async getProfilePicUrlurl(url) {
      // console.log(url);
      const imageUrl = await viewSecuredAttachment(url, this.getToken);

      this.profilePicUrl = imageUrl;
    },
    handleChange(event) {
      const { name, value } = event.target;
      if (name === "employee") {
        this.employee = value;
      }
      if (name === "department") {
        this.department = value;
      }
      if (name === "location") {
        this.location = value;
      }
    },
    handleSubmit(event) {
      event.preventDefault();
    },

    async getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode === 200) {
          const employees = response.data.Data;
          console.log(response.data.Data, "employees")
          const updatedEmployees = await Promise.all(
            employees.map(async (employee) => {
              const imageUrl = await viewSecuredAttachment(
                employee.ProfilePicture,
                this.getToken
              );
              employee.ProfilePicture = imageUrl;
              return employee;
            })
          );

          this.employees = updatedEmployees;
          this.filteredEmployees = this.employees;
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.get_error = error.message;
      } finally {
        this.loading = false;
      }
    },

    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              console.log(response.data.Data, "departments");
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
